module.exports = __webpack_public_path__ + "open-sans-latin-700.15aa9eb56fc3628ba270.woff";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-700.woff
// module id = ../../../../typeface-open-sans/files/open-sans-latin-700.woff
// module chunks = 1 3